import { render, staticRenderFns } from "./NgDialogText.vue?vue&type=template&id=16719247"
import script from "./NgDialogText.vue?vue&type=script&lang=js"
export * from "./NgDialogText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports